import { render, staticRenderFns } from "./gift-shell-home.vue?vue&type=template&id=25ded02a&scoped=true&"
import script from "./gift-shell-home.vue?vue&type=script&lang=js&"
export * from "./gift-shell-home.vue?vue&type=script&lang=js&"
import style0 from "./gift-shell-home.vue?vue&type=style&index=0&id=25ded02a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ded02a",
  null
  
)

export default component.exports